import { formatDate, penceToCurrency, displayUser } from '../../helpers/utils'
import { format } from 'date-fns'

export const triggerEmail = async (action, order, orderProducts, orderProductChanges, shop, currentDate, products, allUsers) => {


    const subject = `EL&N ORDER ${order.id} ${action} - ${shop.brands.name} ${shop.name} - for delivery: ${format(new Date(currentDate),'eee PP')}`

    let body = `<html><head><style>`
    body += `table td { border: 1px solid black; padding: 4px 8px; }`

    body += `</style></head><body>`
    body += `<h2>EL&N ORDER ${action}</h2>`

    body += `<table style="border-collapse: collapse;""><tr><td>For delivery on</td><td><strong>${format(new Date(currentDate),'PPPP')}</strong></td></tr>`
    body += `<tr><td>Shop</td><td><strong>${shop.brands.name} ${shop.name}</strong></td></tr>`
    body += `<tr><td>Order / Invoice num</td><td><strong>${order.id}</strong></td></tr>`
    body += `<tr><td>Purchase order num</td><td><strong>${order.purchase_order_num}</strong></td></tr>`
    body += `<tr><td>Notes</td><td><strong>${order.notes}</strong></td></tr>`

    body += `<tr><td>Created</td><td><strong>${formatDate(order?.created_at, true)} by ${displayUser(allUsers, order?.created_by)}</strong></td></tr>`
    if (action === 'UPDATED') body += `<tr><td>Updated</td><td><strong>${formatDate(order?.updated_at, true)} by ${displayUser(allUsers, order?.updated_by)}</strong></td></tr>`

    body += `</table><br/><a href='https://elnb2b.com/orders/${format(currentDate,'dd-MMM-yyyy')}/${order.id}'>View order on website</a><br/><br/>`
    body += `<table style="border-collapse: collapse;"">`

    let quantityCount = 0
    let costTotal = 0

    let recipients = [
        { name: "EL&N Admin", email: "admin@elnlondon.com" }
    ]

    if (shop.email) {
        recipients.push({ name: shop.name, email: shop.email })
    }

    body += products.map((category) => {
        if (category[1].length === 0) return ""
        const productRows = category[1].map(product => {

            const op = orderProducts.find(op => op.product_id === product.id)
            const change = orderProductChanges.find( c => c.product_id === product.id)

            if (op || change) {
                const total = op ? op.quantity * op.unit_cost : 0
                if (op) quantityCount += op.quantity
                if (op) costTotal += total
                let quantity = op?.quantity 
                let unit_cost = op?.unit_cost
                let beforeQuantity = ''

                if (change && action === 'UPDATED') {
                    if (!isNaN(change.beforeQuantity)) beforeQuantity = `<span style="color:#fd5e6c">(was ${change.beforeQuantity})&nbsp;&nbsp;&nbsp;</span>`
                    quantity = change.quantity 
                    unit_cost = change.unit_cost
                }

                return `<tr><td style='padding-left:16px; ${quantity === 0 ? 'text-decoration:line-through' : ''}'> ${product.name} ${product.details ? `(${product.details})` : ''}</td><td style="text-align:right">${beforeQuantity}${quantity}</td><td style="text-align:right">${penceToCurrency(unit_cost)}</td><td style="text-align:right">${penceToCurrency(total)}</td></tr>`
            }
            
            return ''
        }).join('')
        if (productRows.length === 0) return ''
        return `<tr><td colspan='4'><strong>${category[0]}</strong></td></tr>${productRows}`

    }).join('')

    quantityCount = Number(parseFloat(quantityCount).toFixed(2))

    body += `<tr><td colspan='4'>&nbsp;</td></tr><tr><td><strong>TOTAL</strong></td><td style="text-align:right"><strong>${quantityCount}</strong></td><td></td><td style="text-align:right"><strong>${penceToCurrency(costTotal)}</strong></td></tr>`
    body += "</table>"
    body += `<br/><br/>Emailed to: ${(recipients.map(r => r.email)).join(', ')}<br/><br/>`
    body += "</body></html>"


    if (process.env.REACT_APP_PUBLIC_ENV === 'development') {
        recipients = [
            { name: "EL&N Admin", email: "matt.woodage@gmail.com" }
        ]
    }

    try { 
        await fetch("https://ciemyksmehzdtljwdyot.functions.supabase.co/send-email-via-brevo",
            {
                headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`
                },
                method: "POST",
                mode: 'cors',
                body: JSON.stringify({
                    subject: subject,
                    content: body, 
                    recipients: recipients,
                })
            })

      }
      catch (e) {
          console.error(e)
      }

  }